
// import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
// import CustomCarousel from './CustomCarousel';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
// import FAQSection from './FAQSection';
import FAQItem from './FAQItem';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Taxiserviceinhadapdar() {



  const cardData =
  {
    keyword: 'Taxi Service in Hadapsar',
    heading: 'AB Ghule Cabs: Taxi Service in Hadapsar',
    headingDescription: 'Looking for a reliable taxi service in Hadapsar, Pune? AB Ghule Cabs offers premium and affordable taxi services to cater to all your travel needs. Whether you’re commuting within the city, heading to the airport, or planning an outstation trip, we ensure a seamless and comfortable travel experience.',

    top: 'Our Taxi Services in Hadapsar',

    "topPlaces": [
    {
      title: "Magarpatta City",
      description: "A well-planned, self-sustained township offering shopping malls, restaurants, and recreational activities. It's a great place to enjoy a modern, urban environment."
    },
    {
      title: "Khadakwasla Dam",
      description: "A serene spot located a short drive from Hadapsar, this dam is perfect for a peaceful outing, offering views of the water and surrounding hills."
    },
    {
      title: "The Corinthians Resort & Club",
      description: "A luxury resort with various recreational activities such as a spa, pool, gym, and more. Ideal for a relaxing day trip."
    },
    {
      title: "Nanded City",
      description: "A large integrated township with lush green spaces, Nanded City offers a peaceful retreat, parks, and walking tracks, great for a day of relaxation."
    },
    {
      title: "Sundarban Garden",
      description: "A lovely garden, perfect for picnics and family outings, with well-maintained lawns and play areas for children."
    },
    {
      title: "Hadapsar Lake",
      description: "A peaceful, scenic spot to unwind, perfect for nature walks and bird-watching."
    },
    {
      title: "Seasons Mall",
      description: "A popular shopping destination, Seasons Mall offers everything from shopping to dining and entertainment, including a cinema for movie lovers."
    },
    {
      title: "Hadapsar Industrial Estate",
      description: "While it’s an industrial area, it’s interesting for those looking to understand Pune’s economic development. Several companies in IT and manufacturing operate here."
    },
    {
      title: "Katraj Snake Park",
      description: "Located nearby, the park houses a variety of snakes and other reptiles. It’s an educational visit for nature and wildlife enthusiasts."
    },
    {
      title: "Dhotre Ganapati Temple",
      description: "A popular temple in the area, it draws devotees throughout the year. It’s known for its peaceful ambiance and spiritual significance."
    }
  ],


  services: [
    {
      "name": "Taxi Service in Hadapsar",
      description: "AB Ghule Cabs offers convenient and reliable taxi services in Hadapsar. Whether you're traveling locally or heading out of town, we have a variety of cabs ready to serve you at any time of day. Our Hadapsar taxi services are known for their comfort, punctuality, and affordability. Whether you need a quick ride or a long-distance journey, our taxis ensure a seamless experience."
    },
    {
      "name": "Reliable Taxi in Hadapsar",
      description: "We provide reliable taxi services in Hadapsar that you can count on. Whether it's a local trip or an outstation journey, we ensure timely and safe travel with our experienced drivers. You can depend on us for punctuality and professional service, ensuring your journey is comfortable and worry-free."
    },
    {
      "name": "Affordable Taxi Service Hadapsar",
      description: "Looking for a budget-friendly taxi in Hadapsar? We offer affordable taxi services without compromising on comfort or safety. Whether it's a short ride or a long-distance journey, we have the right options for you. Our competitive prices ensure that you get great value for money, and our vehicles are well-maintained for a smooth and comfortable ride."
    },
    {
      "name": "24/7 Taxi Service in Hadapsar",
      description: "Our 24/7 taxi service in Hadapsar means you can count on us anytime, day or night. Whether you have an early morning flight or a late-night meeting, we are always ready to provide transportation when you need it most. We ensure reliable service at all hours, so you can travel with peace of mind, knowing we are always here to serve you."
    },
    {
      "name": "Airport Taxi Service in Hadapsar",
      description: "Need a taxi to or from Pune Airport? We offer airport taxi services in Hadapsar to ensure a hassle-free journey to and from the airport. Our drivers are familiar with the best routes to ensure you arrive on time. Whether you're catching an early morning flight or need a late-night pickup, we guarantee timely and comfortable transportation."
    },
    {
      "name": "Luxury Taxi Service in Hadapsar",
      description: "For those who want to travel in style, we offer luxury taxi services in Hadapsar. Whether you're going for a special event, business trip, or a luxury experience, our well-maintained luxury cars will meet your needs. Enjoy the ultimate in comfort and sophistication with our top-of-the-line vehicles and professional drivers."
    },
    {
      "name": "Taxi Near Hadapsar",
      description: "Looking for a taxi near Hadapsar? With a fleet of cars nearby, we provide quick, convenient service to ensure you get a cab when you need it. Our cabs are available for both short and long-distance trips, ensuring you're never far from a reliable taxi service. Count on us for fast and efficient service in your area."
    },
    {
      "name": "Cab Service in Magarpatta City and Hadapsar",
      description: "We also provide cab services in Magarpatta City and nearby areas. Whether you're heading for a meeting, a weekend getaway, or a family visit, our Magarpatta City and Hadapsar cab services are the perfect choice for convenience and comfort. Our taxis are always ready to provide a timely, comfortable, and safe journey."
    },
    {
      "name": "Outstation Cabs from Hadapsar",
      description: "Planning an outstation trip? Book outstation cabs from Hadapsar with us! We offer affordable and reliable services for popular destinations like Shirdi, Solapur, Mumbai, and more. Our outstation cabs are well-maintained, providing you with a comfortable journey to your destination. Enjoy a safe and smooth ride with professional drivers."
    },
    {
      "name": "Hadapsar to Mumbai Cabs",
      description: "Need to travel to Mumbai from Hadapsar? Our Hadapsar to Mumbai cab service is perfect for a comfortable and convenient ride. Whether it’s for a business trip, leisure, or any other purpose, our taxis ensure a smooth ride. Our experienced drivers are familiar with the best routes, ensuring you reach your destination on time and without stress."
    },
    {
      "name": "Hadapsar to Shirdi Cab Service",
      description: "Heading to Shirdi from Hadapsar? We provide Hadapsar to Shirdi cab service with well-maintained vehicles, ensuring a comfortable journey. Whether it’s a religious trip or just a visit, our service is perfect for a peaceful ride. Our professional drivers ensure a smooth ride, allowing you to relax and enjoy your trip."
    },
    {
      "name": "Hadapsar to Solapur Cab Service",
      description: "Traveling to Solapur from Hadapsar? Our Hadapsar to Solapur cab service offers a reliable and affordable way to get to your destination. We ensure a comfortable ride with professional drivers who are familiar with the best routes. Whether for business, family, or a religious visit, we offer a timely and safe journey."
    },
    {
      "name": "Taxi Service in Hadapsar Contact Number",
      description: "Contact AB Ghule Cabs at +91 8624029699 for prompt and efficient Taxi Service in Hadapsar. Our customer support team is always available to assist you with your bookings and queries. We ensure a smooth and enjoyable ride for all our customers, providing reliable service that exceeds your expectations."
    }
  ],

  tableData: [
    ["Hadapsar Taxi Service", "-Taxi booking Hadapsar"],
    ["Taxi in Hadapsar", "-Cab Service Hadapsar"],
    ["Hadapsar Cab booking", "-Reliable taxi Hadapsar"],
    ["Affordable taxi Hadapsar", "-24/7 taxi service Hadapsar"],
    ["Airport taxi Hadapsar", "-Luxury taxi Hadapsar"],
    ["Taxi near Hadapsar", "-Cab service in hadapsar"],
    ["Cab service in magar magarpatta city", "-Cab service hadapsar"],
    ["Taxi service in magar magarpatta city", "-Outstation cabs hadapsar"],
    ["Cheap cab service in hadapsar", "-Hadapsar to mumbai cabs"],
    ["Hadapsar to Shirdi Cab", "-Hadapsar to solapur cab service"]
  ],
  
  whychoose: [
    {
      WhyChooseheading: "Reliable and Timely Service",
      WhyChoosedescription: "At AB Ghule Cabs, we provide reliable and timely taxi services in Hadapsar. Whether you're heading for a business meeting, leisure trip, or airport transfer, our taxis are always on time and ready to take you to your destination."
    },
    {
      WhyChooseheading: "Affordable and Transparent Pricing",
      WhyChoosedescription: "We offer affordable and transparent pricing, ensuring you get the best value for your money. Our taxi service fares are clear and competitive, with no hidden charges. You’ll always know the fare before you travel."
    },
    {
      WhyChooseheading: "Variety of Vehicles to Choose From",
      WhyChoosedescription: "We offer a range of vehicles for every type of travel. From budget-friendly sedans to SUVs and luxury cars, you can choose the perfect taxi for your needs and preferences in Hadapsar."
    },
    {
      WhyChooseheading: "Experienced and Professional Drivers",
      WhyChoosedescription: "Our drivers are well-trained, courteous, and experienced in driving through the busy roads of Hadapsar and Pune. They are committed to ensuring a smooth, safe, and comfortable ride for you."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription: "Whether it’s early morning or late at night, AB Ghule Cabs offers 24/7 taxi service in Hadapsar. Our customer support team is always ready to assist you with bookings or any inquiries."
    },
    {
      WhyChooseheading: "Easy Booking Process",
      WhyChoosedescription: "Booking a taxi in Hadapsar with AB Ghule Cabs is simple and convenient. You can book online through our website or app, or just call our customer service to arrange for a ride."
    },
    {
      WhyChooseheading: "Safe and Comfortable Rides",
      WhyChoosedescription: "Our vehicles are regularly maintained, ensuring a safe and comfortable ride for all our customers. We prioritize your comfort and safety on every trip."
    }
  ]
  
  
  

  }

  const faqData = [
    {
      id: 'FAQ1',
      question: 'How can I book a taxi in Hadapsar?',
      answer: 'You can easily book a taxi in Hadapsar via our website, mobile app, or by calling our customer service team for assistance.',
    },
    {
      id: 'FAQ2',
      question: 'What is the fare for a taxi ride within Hadapsar?',
      answer: 'The fare for a taxi ride within Hadapsar typically starts from ₹500 for a sedan for a short trip.',
    },
    {
      id: 'FAQ3',
      question: 'Can I book a taxi for an airport transfer from Hadapsar?',
      answer: 'Yes, we offer taxi services for airport transfers to and from Pune Airport. The fare for a ride from Hadapsar to the airport is approximately ₹800 for a sedan.',
    },
    {
      id: 'FAQ4',
      question: 'Are the vehicles in good condition?',
      answer: 'Yes, all our vehicles are well-maintained and regularly serviced to ensure a safe and comfortable journey for all passengers.',
    },
    {
      id: 'FAQ5',
      question: 'How do I pay for my taxi ride?',
      answer: 'You can pay for your ride using cash, credit/debit cards, or online payments through our mobile app for your convenience.',
    },
    {
      id: 'FAQ6',
      question: 'Can I book a taxi for an intercity ride?',
      answer: 'Yes, we offer intercity taxi services from Hadapsar to various cities like Mumbai, Nashik, Lonavala, and more.',
    },
    {
      id: 'FAQ7',
      question: 'Are the taxi drivers experienced?',
      answer: 'Yes, all our drivers are highly experienced, trained, and background-checked to ensure your safety and comfort during the ride.',
    },
  ];
  
  const testimonials = [
    {
      id: 1,
      name: 'Mr. Rahul Deshmukh',
      feedback: 'I always rely on AB Ghule Cabs for my daily commuting in Hadapsar. Their service is always prompt, the drivers are courteous, and the vehicles are clean and well-maintained. Highly recommended!',
      rating: 5,
    },
    {
      id: 2,
      name: 'Ms. Anjali Joshi',
      feedback: 'Booking a taxi with AB Ghule Cabs in Hadapsar is super easy, and the fares are very reasonable. I had a smooth ride to Pune Airport and will definitely choose them for my next trip.',
      rating: 5,
    },
  ];
  
  
  






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8624029699",
      

    ],
    email: "booking@abghulecabs.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Mumbai Cab Service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Mumbai to Shirdi Cab",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Mumbai Darshan Cabs",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Mumbai to Vadodara Taxi",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Mumbai to Pune Cab",
    },
    {
      place: "/images/keyword/6.jpg",
      text: " Mumbai to Goa Taxi",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Mumbai Airport Cab",
    },

    {
      place: "/images/keyword/8.jpg",
      text: "Mumbai Surat Cabs",
    },

    {
      place: "/images/keyword/9.jpg",
      text: "Mumbai to Mahabaleshwar Cab",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Mumbai to Konkan Cab",
    },

    {
      place: "/images/keyword/11.jpg",
      text: "Pune Cab Service",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune Taxi Hire",
    },

    {
      place: "/images/keyword/13.jpg",
      text: "Pune Online Cab Booking",
    },

    {
      place: "/images/keyword/14.jpg",
      text: "Best Cab Service in Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Pune to Mumbai Cabs",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Nashik Cabs",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Mahabaleshwar Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Lonavala Cabs",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Shirdi Cab",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Lavasa city cabs",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Bhimashankar Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Indore Cabs",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Konkan Darshan Cabs",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune Outstation Cabs",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Panchgani Cab Fare",
    },
    {
      place: "/images/keyword/26.jpg",
      text: "Pune to Mumbai International Airport Cab",
    },
    {
      place: "/images/keyword/27.jpg",
      text: "Ashtavinayak Darshan Cab",
    },
  ];


  const images = [
    { src: "/images/our-fleet/1.jpg", alt: "Image 1" },
    { src: "/images/our-fleet/2.jpg", alt: "Image 2" },
    { src: "/images/our-fleet/3.jpg", alt: "Image 3" },
    { src: "/images/our-fleet/4.jpg", alt: "Image 4" },
    { src: "/images/our-fleet/5.jpg", alt: "Image 5" },
    { src: "/images/our-fleet/6.jpg", alt: "Image 6" },
    { src: "/images/our-fleet/7.jpg", alt: "Image 7" },
    { src: "/images/our-fleet/8.jpg", alt: "Image 8" },
    { src: "/images/our-fleet/9.jpg", alt: "Image 9" },
  ];





  return (
    <div>
      <Helmet>
  <title>Contact: +91 8624029699 | AB Ghule Cabs | Taxi Service in Hadapsar | Reliable & Affordable Cabs</title>
  <meta name="description" content="Book a reliable and affordable taxi service in Hadapsar with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings." />
  <meta name="keywords" content="Hadapsar Taxi Service, Taxi Booking Hadapsar, Taxi in Hadapsar, Cab Service Hadapsar, Hadapsar Cab Booking, Reliable Taxi Hadapsar, Affordable Taxi Hadapsar, 24/7 Taxi Service Hadapsar, Airport Taxi Hadapsar, Luxury Taxi Hadapsar, Taxi Near Hadapsar, Cab Service in Hadapsar, Cab Service in Magarpatta City, Taxi Service in Magarpatta City, Outstation Cabs Hadapsar, Cheap Cab Service in Hadapsar, Hadapsar to Mumbai Cabs, Hadapsar to Shirdi Cab, Hadapsar to Solapur Cab Service" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Taxi Service in Hadapsar | Reliable & Affordable Cabs" />
  <meta property="og:description" content="Book a reliable and affordable taxi service in Hadapsar with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings." />
  <meta property="og:image" content="https://abghulecabs.com/images/taxi-service-hadapsar.jpg" />
  <meta property="og:url" content="https://abghulecabs.com/taxi-service-hadapsar" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="AB Ghule Cabs" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "AB Ghule Cabs - Taxi Service in Hadapsar",
        description: "Book a reliable and affordable taxi service in Hadapsar with AB Ghule Cabs. 24/7 taxi service for local and outstation trips. Call +91 8624029699 for bookings.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Hadapsar, Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411028",
          "addressCountry": "IN"
        },
        "telephone": "+91-8624029699",
        "url": "https://abghulecabs.com/taxi-service-hadapsar",
        "logo": "https://abghulecabs.com/images/taxi-service-hadapsar.jpg",
        "image": "https://abghulecabs.com/images/taxi-service-hadapsar.jpg",
        "priceRange": "₹1000 - ₹5000",
        "offers": {
          "@type": "Offer",
          "url": "https://abghulecabs.com/taxi-service-hadapsar",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2024-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "150"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Vikram P"
            },
            "datePublished": "2024-09-10",
            "reviewBody": "Great service! The driver was punctual and courteous. Affordable prices for a trip to Shirdi from Hadapsar."
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Shruti S"
            },
            "datePublished": "2024-07-15",
            "reviewBody": "Reliable taxi service in Hadapsar. We used their service for a trip to Mumbai, and it was comfortable and smooth."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Hadapsar and Surrounding Areas Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5193",
            "longitude": "73.9297"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://abghulecabs.com/taxi-service-hadapsar"
        },
        "keywords": "Hadapsar Taxi Service, Taxi Booking Hadapsar, Taxi in Hadapsar, Cab Service Hadapsar, Hadapsar Cab Booking, Reliable Taxi Hadapsar, Affordable Taxi Hadapsar, 24/7 Taxi Service Hadapsar, Airport Taxi Hadapsar, Luxury Taxi Hadapsar, Taxi Near Hadapsar, Cab Service in Hadapsar, Cab Service in Magarpatta City, Taxi Service in Magarpatta City, Outstation Cabs Hadapsar, Cheap Cab Service in Hadapsar, Hadapsar to Mumbai Cabs, Hadapsar to Shirdi Cab, Hadapsar to Solapur Cab Service"
      }
    `}
  </script>
</Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>{cardData.keyword}</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/57.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#FF4101', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px',
                        transition: 'transform 0.2s'
                      }}

                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ab Ghule Cabs</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        {faqData.map((faq) => (
                          <FAQItem key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <div>

                <div className="contact-box Borderr">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details">
                    <p><strong className='darkcolor'>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}


              <div className="gallery-container">
                <h2 className="gallery-title">Our Fleets</h2>
                <div className="gallery-row d-flex flex-wrap">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
                  {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border "
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #FF4101',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF4101' }}>
                      <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8624029699" className="d-block  text-white">+91 8624029699</a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                        <a href="mailto:booking@abghulecabs.com" className=" text-white d-block">
                          booking@abghulecabs.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#FF4101' }}>
                        <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                        <p className="whit text-white ">
                          <i> AB Ghule Cabs<br />
                            R -10 Office No -1606,   <br />
                            Life Republic Mulshi, Marunji  <br />
                            Pune, Maharashtra - 411057.

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Taxiserviceinhadapdar;